var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex items-center w-full" }, [
    _c(
      "div",
      { staticClass: "w-6/12" },
      [
        _c("FormInputGroup", {
          staticClass: "h-input",
          attrs: {
            id: "min",
            type: "number",
            placeholder: _vm.leftPlaceholder,
            name: "min",
            value: _vm.minValue,
            debounceTime: 500,
            inputClass: _vm.inputClass,
            inputClasses: _vm.inputClasses,
            prefix: _vm.prefix,
            suffix: _vm.suffix,
            suffixClasses: _vm.suffixClasses,
            prefixClasses: _vm.prefixClasses,
          },
          on: {
            input: function ($event) {
              return _vm.handleInput("minValue", $event)
            },
          },
        }),
      ],
      1
    ),
    _c("p", { staticClass: "mx-2 mt-1" }, [_vm._v(" - ")]),
    _c(
      "div",
      { staticClass: "w-6/12" },
      [
        _c("FormInputGroup", {
          staticClass: "h-input",
          attrs: {
            id: "max",
            type: "number",
            name: "max",
            placeholder: _vm.rightPlaceholder,
            value: _vm.maxValue,
            inputClass: _vm.inputClass,
            debounceTime: 500,
            inputClasses: _vm.inputClasses,
            suffixClasses: _vm.suffixClasses,
            prefixClasses: _vm.prefixClasses,
            prefix: _vm.prefix,
            suffix: _vm.suffix,
          },
          on: {
            input: function ($event) {
              return _vm.handleInput("maxValue", $event)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }